jQuery_T4NT(document).ready(function($) {
  /**
   * Dynamic Discount Badge on Variant Selection Change
   */
  $(document).on("variant:change", function(evt, variant) {
    if (variant && variant.compare_at_price > variant.price) {
      var save = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
      var text = save + "% OFF";
      var $badges = $('.onsale.nt_label, .pdp_onsale_badge');
      $badges.find('>span').text(text);
      $badges.show();
    } else {
      $('.pdp_onsale_badge').hide();
    }
  });

  /**
   * Khadlaj Quick Add (+) Button Feedback
   */
  var $activeQaBtn = null;
  $(document).on("click", ".khadlaj_quick_add", function(e) {
    e.stopPropagation();
    if ($(this).hasClass("js_addtc")) {
      $activeQaBtn = $(this);
      $activeQaBtn.addClass("is-loading");
    }
  });

  $(document).on("CartUpdateSuccess", function() {
    if ($activeQaBtn && $activeQaBtn.length) {
      $activeQaBtn.removeClass("is-loading loading").addClass("is-added");
      var $temp = $activeQaBtn;
      setTimeout(function() {
        $temp.removeClass("is-added");
      }, 2000);
      $activeQaBtn = null;
    }
  });
});

document.addEventListener("DOMContentLoaded", function() {
    document.querySelector('.moreless-button').addEventListener('click', function() {
        var moreText = document.querySelector('.moretext');
        var button = this;
        
        if (moreText.style.display === "none" || moreText.style.display === "") {
            moreText.style.display = "block";
            button.textContent = "Read less";
        } else {
            moreText.style.display = "none";
            button.textContent = "Read more";
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {

  document.querySelector(".shopify-whatsApp a").addEventListener("click", function() {
    if (typeof gtag === 'function') {
      gtag('event', 'click', {
        'event_category': 'Button',
        'event_label': 'WhatsApp Button',
        'value': 1
      });
    }
  });
});
